import { createReducer, on } from '@ngrx/store';
import {
  getApps,
  setGenStatus,
  sentApps,
  getAppById,
  sentDeleteApps,
  deleteAppsSuccess,
  setApps,
  saveApps,
  updateApps,
  deleteApps,
  setAppId,
  newAppCreated,
  getSidBasedApps,
  setSidBasedApps,
  getAppsBasedOnSearch,
  triggerPrototypingAppGeneration,
  setAllApps,
  getAllApps,
  getErrorMessage,
  getGeneratedAppUrl,
  setGeneratedAppUrl,
  setAppById,
  getAppsForOrg,
  getUsersFromApp,
  saveUserToApp,
  setUsersFromApp,
  deleteUsersFromApp,
  saveUserToAppStas,
  setAppsDrop,
  getGenerationStatus,
  setLastPublish,
  getLastPublish,
  setAppMetaInfo,
  setFsLoginInitiated,
  saveAppSuite,
  getDBlist,
  getIndepApps,
  getMemApps,
  setDBlist,
  setIndepApps,
  setMemApps,
  getMemTechnologyStack,
  setMemTechnologyStack,
  getMemDBlist,
  setMemDBlist,
  getFullApps,
  getAllAppsFromSuite,
  setAllAppsFromSuite,
  setCurrentAppFullData,
  setGenerationStage
} from '../actions/applifecycle.actions';

export interface AppsState {
  data: any;
  getAppsApiConstants: any;
  appsData: any;
  saveAppApiConstants: any;
  orgsData: any;
  getOrgConstants: any;
  loader: boolean;
  selectedAppdata: any;
  appId: string;
  searchText: string;
  sidAppData: any;
  allAppList: any;
  appDropList: any;
  updateSuccess: boolean;
  deleteSuccess: boolean;
  currentAppFullData: any;
  generationStage: string;
}

export const initialState: AppsState = {
  data: [],
  getAppsApiConstants: {},
  appsData: {},
  saveAppApiConstants: {},
  orgsData: {},
  getOrgConstants: {},
  selectedAppdata: {},
  loader: false,
  appId: '',
  searchText: '',
  sidAppData: {},
  allAppList: [],
  appDropList: [],
  updateSuccess: false,
  deleteSuccess: false,
  currentAppFullData: null,
  generationStage: 'collecting'
};

export const appsReducer = createReducer(
  initialState,
  on(setGenerationStage, (state, { stage }) => ({
    ...state,
    generationStage: stage
  })),
  on(getApps, (state, { getAppsApiConstants }) => ({
    ...state,
    ...getAppsApiConstants,
    loader: true,
    updateSuccess: false,
    deleteSuccess: false
  })),
  on(getAppsForOrg, (state, { getAppsApiConstants }) => ({
    ...state,
    ...getAppsApiConstants,
    loader: true,
    updateSuccess: false,
    deleteSuccess: false
  })),
  on(setApps, (state, { appList }) => ({
    ...state,
    data: appList,
    sidAppData: {},
    loader: false,
    updateSuccess: false,
    deleteSuccess: false
  })),
  on(deleteAppsSuccess, (state, { success }) => {
    // const allappsData = state.data;
    // const filteredData = allappsData.filter(
    //   (user: { sid: string }) => user.sid !== appId
    // );

    return {
      ...state,
      loader: false,
      updateSuccess: false,
      deleteSuccess: success
    };
  }),
  on(setAllApps, (state, { allAppList, totalRecords }) => ({
    ...state,
    ...{ allAppList, totalRecords },
    loader: false,
    updateSuccess: false,
    deleteSuccess: false
  })),
  on(setAppsDrop, (state, { appDropList }) => ({
    ...state,
    ...{ appDropList }
  })),
  on(setAppId, (state, { appId }) => {
    let selectedAppdata: any = state.selectedAppdata || {};

    if (state.allAppList?.length > 0) {
      const found = state.allAppList.find((app) => app.sid === appId);
      if (found) {
        selectedAppdata = found;
      }
    }

    return {
      ...state,
      appId,
      selectedAppdata,
      sidAppData: {},
      loader: false
    };
  }),
  on(getAppById, (state) => ({
    ...state,
    loader: true,
    updateSuccess: false,
    deleteSuccess: false
  })),
  on(setAppById, (state, { appData }) => ({
    ...state,
    loader: false,
    sidAppData: appData
  })),
  on(sentApps, (state) => ({
    ...state,
    createdApp: {},
    loader: true
  })),
  on(saveApps, (state, { appsData }) => {
    // in case of move or remove from suite, the independent/mem app is still there. First delete the old app and add the new one
    const i = state.data?.findIndex((d) => d.sid === appsData.sid);
    if (i > -1) {
      state.data.splice(i, 1);
    }
    const allData = state.data.length > 0 ? [...state.data, appsData] : [appsData];
    return {
      ...state,
      data: allData,
      sidAppData: {},
      loader: false,
      updateSuccess: false,
      deleteSuccess: false
    };
  }),
  on(updateApps, (state, { updateAppsData }) => {
    console.log(updateAppsData);

    return {
      ...state,
      sidAppData: updateAppsData,
      loader: false,
      updateSuccess: true,
      deleteSuccess: false
    };
  }),
  on(sentDeleteApps, (state) => ({
    ...state,
    loader: true
  })),
  on(newAppCreated, (state, { createdApp }) => ({
    ...state,
    ...{ createdApp }
  })),
  on(deleteApps, (state, { appId }) => {
    // const allappsData = state.data;
    // const filteredData = allappsData.filter(
    //   (user: { sid: string }) => user.sid !== appId
    // );

    return {
      ...state,
      loader: false,
      updateSuccess: false,
      deleteSuccess: true
    };
  }),
  on(getSidBasedApps, (state) => {
    return {
      ...state,
      loader: true,
      sidAppData: {},
      updateSuccess: false,
      deleteSuccess: false
    };
  }),
  on(setSidBasedApps, (state, { sidAppData }) => {
    return {
      ...state,
      loader: false,
      sidAppData: sidAppData,
      selectedAppdata: sidAppData
    };
  }),
  on(setCurrentAppFullData, (state, { currentAppFullData }) => {
    return {
      ...state,
      currentAppFullData: currentAppFullData
    };
  }),
  on(getAppsBasedOnSearch, (state, { apiConstants, searchFields }) => {
    console.log(apiConstants, searchFields);
    return {
      ...state,
      searchFields,
      loader: true,
      ...apiConstants
    };
  }),
  on(triggerPrototypingAppGeneration, (state, { genAppApi, genParams }) => {
    return {
      ...state,
      ...{ genAppApi },
      ...{ genParams }
    };
  }),
  on(getErrorMessage, (state, errorMessage) => {
    return {
      ...state,
      ...{ errorMessage },
      loader: false
    };
  }),
  on(getGeneratedAppUrl, (state) => {
    return {
      ...state,
      genUrl: {}
    };
  }),
  on(setGeneratedAppUrl, (state, { genUrl }) => {
    return {
      ...state,
      genUrl: genUrl
    };
  }),
  on(getGenerationStatus, (state, { genStatusApi }) => {
    return {
      ...state,
      ...genStatusApi
    };
  }),
  on(setGenStatus, (state, { genStatus }) => {
    return {
      ...state,
      ...{ genStatus }
    };
  }),
  on(saveUserToApp, (state, { params }) => {
    return {
      ...state,
      ...{ params }
    };
  }),
  on(getUsersFromApp, (state, { apiConstants }) => {
    return {
      ...state,
      ...apiConstants
    };
  }),
  on(setUsersFromApp, (state, { usersBasedOnApp }) => {
    return {
      ...state,
      ...{ usersBasedOnApp }
    };
  }),
  on(deleteUsersFromApp, (state, { params }) => {
    return {
      ...state,
      ...{ params }
    };
  }),
  on(saveUserToAppStas, (state, { userSaveStatus }) => {
    return {
      ...state,
      ...{ userSaveStatus }
    };
  }),
  on(getLastPublish, (state, { lastPublishApi }) => ({
    ...state,
    ...lastPublishApi
  })),
  on(setLastPublish, (state, { publishLog }) => ({
    ...state,
    ...{ publishLog }
  })),
  on(setAppMetaInfo, (state, { metaInfo }) => ({
    ...state,
    ...{ metaInfo }
  })),
  on(setFsLoginInitiated, (state, { loggedIn }) => ({
    ...state,
    ...{ loggedIn }
  })),
  on(saveAppSuite, (state) => {
    return {
      ...state,
      createdApp: {},
      loader: true
    };
  }),
  on(getIndepApps, (state) => ({
    ...state,
    loader: true
  })),
  on(setIndepApps, (state, { indepApps }) => ({
    ...state,
    ...{ indepApps },
    loader: false
  })),
  on(getDBlist, (state) => ({
    ...state,
    loader: true
  })),
  on(setDBlist, (state, { dbList }) => ({
    ...state,
    ...{ dbList },
    loader: false
  })),
  on(getMemApps, (state) => ({
    ...state,
    loader: true
  })),
  on(setMemApps, (state, { memAppList }) => ({
    ...state,
    ...{ memAppList },
    loader: false
  })),
  on(getMemTechnologyStack, (state, { apiConstants, appId }) => ({
    ...state,
    ...{ apiConstants },
    ...{ appId },
    loader: true
  })),
  on(setMemTechnologyStack, (state, { memtechnologyStackData }) => ({
    ...state,
    ...{ memtechnologyStackData },
    loader: false
  })),
  on(getMemDBlist, (state) => ({
    ...state,
    loader: true
  })),
  on(setMemDBlist, (state, { memdbList }) => ({
    ...state,
    ...{ memdbList },
    loader: false
  })),
  on(getFullApps, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants,
    loader: true
  })),
  on(getAllAppsFromSuite, (state) => ({
    ...state,
    loader: true
  })),
  on(setAllAppsFromSuite, (state, { allAppFromSuiteList }) => ({
    ...state,
    ...{ allAppFromSuiteList },
    loader: false
  })),
);
